import cx from 'classnames';
import React, {CSSProperties, FC} from 'react';
import {formInputRadius} from '~libSass/base/_exports.sass';

import './Box.sass';

interface BoxProps {
  children: React.ReactNode;
  center?: boolean;
  className?: string;
  padding?: number;
  borderRadius?: number;
  height?: CSSProperties['height'];
}

export const Box: FC<BoxProps> = ({
  children,
  center,
  className = '',
  padding = 16,
  borderRadius = formInputRadius,
  height,
}) => (
  <div
    className={cx('box', className, {
      'box-center': center,
    })}
    style={{padding, borderRadius, height}}
  >
    {children}
  </div>
);
